import { useEffect, useState } from 'react';
import { supabase } from './supabaseClient';

/* ══════════════════════════════════════════════════════════════════════════
   Trial length — one source for the terminal and the landing
   ─────────────────────────────────────────────────────────────────────────
   The database decides the trial length (public.trial_policy(), landing
   repo migration 20261024120000, live since 2026-10-24): 14 days, once +7
   after the first alert. The fallback below (used only if the RPC fails)
   repeats the same rule. The landing keeps the same numbers in
   src/config/site.js (TRIAL_DAYS, TRIAL_BONUS_DAYS) for its static copy.
   Accounts created before the cutover keep 30 days; their own length comes
   from get_user_access().trial_days_total, not from here.
   ══════════════════════════════════════════════════════════════════════════ */
export const TRIAL_FALLBACK = { trialDays: 14, bonusDays: 7 };

let cached = null;
export async function fetchTrialPolicy() {
  if (cached) return cached;
  try {
    const { data, error } = await supabase.rpc('trial_policy');
    const row = Array.isArray(data) ? data[0] : data;
    cached = !error && row?.trial_days
      ? { trialDays: row.trial_days, bonusDays: row.bonus_days || 0 }
      : TRIAL_FALLBACK;
  } catch {
    cached = TRIAL_FALLBACK;
  }
  return cached;
}

export function useTrialPolicy() {
  const [policy, setPolicy] = useState(cached || TRIAL_FALLBACK);
  useEffect(() => {
    let alive = true;
    fetchTrialPolicy().then(p => { if (alive) setPolicy(p); });
    return () => { alive = false; };
  }, []);
  return policy;
}
